export type Theme = 'light' | 'dark'

export const THEMES: Theme[] = ['light', 'dark']
export const DEFAULT_THEME: Theme = 'light'
export const KEY_THEME = '@quadralize/theme'
